*,
:after,
:before {
  box-sizing: border-box;
}

img {
  box-sizing: content-box;
  border-style: none;
  max-width: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--csc-font-headline);
}

a {
  color: var(--base-font-color, #4c4c4c);
  text-decoration: none;
}

a:hover,
.sg-cw-button:hover {
  color: var(--color-primary, #c30c15);
}

.sg-cw-button {
  color: #8e8e8e;
}

.hide {
  display: none;
}

.filter-item input,
.filter-item label,
a#btn-reset-filters:hover,
button:hover {
  cursor: pointer;
}

input[hidden] {
  display: none;
}

.shadow {
  padding-bottom: 9px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
}

cwc-button-itinerary,
cwc-order-at-home {
  display: flex;
  flex-flow: column wrap;
  gap: 1rem;
  max-width: 50rem;
}

button.sg-cw-button {
  flex: 1 1 0%;
  min-height: 2.5rem;
  min-width: 2.5rem;
  border: 0;
  border-radius: var(--button-border-radius, 3px);
  line-height: var(--button-flat-raised-line-height);
  text-align: center;
  margin: 10px 0 0;
}

button.sg-cw-raise {
  background-color: var(--button-raised-background-color, #c30c15);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  color: var(--button-raised-text-color);
  font-family: var(--button-flat-raised-font);
  /* font-weight: var(--button-raised-font-weight); */
  font-weight: var(--csc-button--basic--font-weight, 700);
}

button.sg-cw-raise.sg-cw-raise-secondary {
  border: 1px solid var(--button-raised-background-color, #c30c15);
  color: var(--button-raised-background-color, #c30c15);
  background-color: var(--button-raised-text-color, var(--color-white));
}

button.sg-cw-raise:hover,
button.sg-cw-raise.sg-cw-raise-secondary:hover {
  background-color: var(--button-raised-hover-background-color, #a00d0c);
  color: var(--button-raised-hover-text-color, var(--color-white));
  text-decoration: none;
}

@media only screen and (min-width: 640px) {
  cwc-button-itinerary,
  cwc-order-at-home {
    flex-direction: row;
  }
}

/**
 * Scrollbar
 */
::-webkit-scrollbar {
  width: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.sg-cw-section-heading {
  margin-bottom: 1rem;
  background-size: cover;
}

.sg-cw-section-heading-content {
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 auto;
  max-width: 1400px;
  align-items: center;
  padding: 0 1rem;
  text-align: center;
  justify-content: center;
}

.sg-cw-section-heading-headline {
  font-size: var(--headline-font-size, 2.25rem);
  margin-bottom: var(--headline-margin-bottom, 0.875rem);
  padding: 0;
  line-height: 1.2;
}

/**
 * Main container with basic settings
 */
cwc-store-locator {
  max-width: 1400px;
  margin: 0px auto;
  /* min-height: 860px; */
  width: 100%;
  display: block;
}

/**
 * Map container
 * map height must always be explicitly specified
 */
cwc-map {
  display: block;
  height: 100vh;
  max-width: 100%;
  width: 100%;
}

cwc-map.load {
  display: none;
}

cwc-map-content {
  display: block;
  position: relative;
  /* height: 100%; */
  margin: 0;
  padding: 0;
  overflow: hidden;
}

cwc-map-content .button-itinerary {
  color: var(--color-primary, #c30c15);
  cursor: pointer;
}

cwc-map-sidebar {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  max-width: 343px;
  width: 100%;
  height: 100%;
  background: #fff;
  transition: left 0.5s ease-out;
  -webkit-transition: left 0.5s ease-out;
}

cwc-map.sidebar-on {
  max-width: calc(100% - 343px);
  left: 343px;
  transition: 0.5s ease-out;
  -webkit-transition: 0.5s ease-out;
}

cwc-map-sidebar.sidebar-on {
  display: block;
}

cwc-map-sidebar.sidebar-on .onsite-printer-only-checkbox {
  display: none;
}

cwc-map-search.sidebar-on {
  max-width: 27%;
  height: 50px;
  padding: 0 10px 10px 10px;
  background: none;
}

cwc-map-search.sidebar-on .pac-target-input {
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  padding: 10px;
  border: 1px solid #555;
  background: #f5f5f5;
}

cwc-map-search.sidebar-on .pac-target-buttons {
  top: 1px;
  right: 1px;
}

cwc-location.last {
  padding-bottom: 10px;
}

cwc-map-sidebar cwc-location {
  position: relative;
  display: block;
  padding: 10px 10px 0 10px;
}

cwc-map-sidebar cwc-filter {
  display: block;
  margin: 16px 13px 0 10px;
  background-color: #f5f5f5;
  border-bottom: 10px solid #fff;
}

cwc-map-sidebar cwc-location p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #8e8e8e;
}

cwc-map-sidebar cwc-location h3 {
  margin: 0;
  font-size: 16px;
}

cwc-map-sidebar button {
  display: block;
  width: 100%;
  border: none;
  background: #fff;
  text-align: left;
  color: var(--color-primary, #c30c15);
  align-items: center;
  font-size: 14px;
  line-height: 31px;
}

cwc-map-sidebar button.location-back {
  padding-bottom: 0;
}

#product-form button {
  width: 15%;
  color: #1d1c1c;
}

cwc-map-content button span {
  vertical-align: middle;
}

cwc-sidebar-slide {
  position: absolute;
  top: 8px !important;
  left: 0;
  cursor: pointer;
}

cwc-sidebar-slide button {
  width: 23px;
  height: 48px;
  cursor: pointer;
  border-top: none;
  border-right: none;
  border-bottom: none;
  border-left: 1px groove #ccc;
  box-shadow: none;
  color: rgba(0, 0, 0, 0.6);
  min-width: 23px;
  padding: 0;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
}

cwc-map-sidebar.slide {
  left: -343px;
  transition: left 0.5s ease-out;
  -webkit-transition: left 0.5s ease-out;
}

cwc-map.slide {
  left: 0;
  max-width: 100%;
  transition: 0.5s ease-out;
  -webkit-transition: 0.5s ease-out;
}

cwc-sidebar-header {
  display: block;
  position: relative;
  height: auto;
  z-index: 2;
}

cwc-sidebar-body {
  display: block;
  position: relative;
  height: 100%;
  overflow: auto;
  margin-top: -9px;
  padding-bottom: 10px;
  z-index: 1;
}

.sidebar-on cwc-map-search {
  background: #fff;
  display: block;
  position: relative;
}

.sidebar-on input.pac-target-input {
  width: calc(100% - 15px);
  background-color: #f5f5f5;
  margin: 9px 10px 0 10px;
  border: 1px solid #666;
}

input.pac-target-input.error {
  border: 2px solid #c30c15;
}

.sidebar-on .pac-target-buttons {
  height: 44px;
  right: 10px;
  top: 1px;
}

.sidebar-on button.icon-close,
.sidebar-on button.icon-location {
  float: left;
  background: none;
  border: none;
  box-shadow: none;
}

cwc-location-info {
  display: block;
  width: 100%;
  background-color: #f5f5f5;
  padding: 12px 16px;
}

cwc-location-details .info-content {
  width: calc(100% - 85px);
}

cwc-location-info :nth-child(2) {
  margin: 4px 0;
}

cwc-location-info:hover {
  cursor: pointer;
  background-color: #fafafa;
}

cwc-location-info .info-content .more-info {
  color: var(--color-primary, #c30c15);
}

cwc-location-details .info-content span:last-child,
cwc-location-info .info-content span:last-child {
  color: #4c4c4c;
  font-weight: 700;
}

cwc-location-info:hover .more-info {
  color: #8e8e8e;
}

div.accordion > span.badge.show {
  display: inline;
}

cwc-location-details,
cwc-location-itinerary {
  display: none;
}

cwc-location-details .cover-image {
  display: flex;
}

cwc-location-details.show,
cwc-location-itinerary.show {
  display: block;
  margin-top: 15px;
}

cwc-location-details .details-list {
  font-size: 16px;
}

cwc-location-details .details-list > div {
  background-color: #f5f5f5;
  padding: 10px;
  margin-top: 10px;
}

cwc-location-details .icon {
  color: var(--color-primary, #c30c15);
  margin-right: 10px;
  height: 40px;
  display: inline-block;
  vertical-align: middle;
}

cwc-location-details .icon.right {
  position: absolute;
  right: 0;
  top: 0;
  margin: 0;
}

cwc-filter .icon.right {
  display: inline-block;
  vertical-align: text-top;
  margin-left: 15px;
}

cwc-filter .accordion span:first-child {
  display: inline-block;
  margin: 9px 0;
  font-weight: 500;
}

cwc-filter .panel div:last-child {
  margin-bottom: 15px;
}

cwc-location-details .icon.icon-clock {
  font-size: 21px;
  margin-left: 2px;
  margin-right: 13px;
}

cwc-location-details .store-details > div {
  position: relative;
  margin-bottom: 10px;
}

cwc-location-details .store-details div span {
  padding: 5px 0;
}

cwc-location-details .store-details div:last-child {
  margin-bottom: 0;
}

cwc-location-details .store-details .products .panel h3 {
  margin-top: 15px;
}

cwc-location-details .store-details div .panel {
  margin-bottom: 15px;
}

/**
* PRODUCT IMAGES
*/
cwc-location-details .product_images h3 {
  padding-bottom: 10px;
}

cwc-location-details .img-items-wrapper {
  position: relative;
  overflow: hidden;
}

cwc-location-details .product_images .button {
  padding-top: 10px;
  cursor: pointer;
  clear: both;
}

cwc-location-details .product_images .button:hover {
  color: var(--color-primary, #c30c15);
}

cwc-location-details .product_images .img-items.open {
  display: block;
  width: 346px !important;
  clear: both;
}

cwc-location-details .product_images .img-items.open .img-item {
  display: block;
  float: left;
  max-width: calc(50% - 25px);
  margin-right: 4px;
}

cwc-location-details .img-item img {
  cursor: pointer;
}

cwc-product-images {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  text-align: center;
  align-content: center;
  z-index: 3;
}

cwc-product-images .preview-items-wrapper {
  position: relative;
  width: 84%;
  margin: 0 auto;
  overflow: hidden;
  z-index: 1;
}

cwc-location-details .img-item {
  max-width: 110px;
  flex: 0 0 100%;
}

cwc-location-details .img-items {
  position: relative;
  display: flex;
  gap: 4px;
  top: 0;
  left: 0;
}

cwc-product-images .preview-slider {
  position: relative;
  height: inherit;
  top: 0;
  left: 0;
  overflow: hidden;
}

cwc-product-images .img-items {
  display: flex;
  gap: 10px;
  position: absolute;
  top: 0;
  left: 0;
  transition: left 0.5s ease-out;
  -webkit-transition: left 0.5s ease-out;
}

cwc-product-images .img-items .img-item.active {
  display: block;
  transition: 0.5s ease-out;
  -webkit-transition: 0.5s ease-out;
}

cwc-product-images .thumb-items {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

cwc-product-images .thumb-items .img-item {
  height: 100%;
  padding: 0 2px;
  opacity: 0.7;
  cursor: pointer;
  margin-bottom: 2px;
}

cwc-product-images .thumb-items .img-item:hover {
  opacity: 1;
}

cwc-product-images .thumb-items .img-item.active {
  opacity: 1;
  margin-bottom: 5px;
}

cwc-product-images .thumb-items .img-item.active img {
  width: calc(100% - 4px);
  border: 2px solid #c30c15;
}

cwc-product-images .thumb-items .img-item:first-child {
  padding-left: 0;
}

cwc-product-images .thumb-items .img-item:last-child {
  padding-right: 0;
}

cwc-product-images button[class^='icon-'] {
  position: absolute;
  background: none;
  color: #fff;
  border: none;
}

cwc-product-images button.icon-close {
  top: 10px;
  right: 10px;
}

cwc-product-images button.icon-arrow-right {
  top: 40%;
  right: 0;
  z-index: 2;
}

cwc-product-images button.icon-arrow-left {
  top: 40%;
  left: 0;
  z-index: 2;
}

.img-items-wrapper .panel {
  display: block;
  width: 100%;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
  -webkit-transition: max-height 0.5s ease-out;
}

/** 
* ITINERARY
*/
cwc-map-content .button-itinerary,
cwc-map-content .accordion,
cwc-filter .accordion {
  cursor: pointer;
  width: 100%;
  outline: none;
  transition: 0.4s;
  -webkit-transition: 0.4s;
}

cwc-location .button-itinerary {
  position: absolute;
  width: 85px;
  text-align: center;
  line-height: 1;
  font-weight: 600;
  font-size: small;
}

cwc-location-info .button-itinerary {
  top: 19px;
  right: 15px;
}

cwc-location-details .button-itinerary {
  top: 0px !important;
  right: 0px;
  position: relative;
}

.button-itinerary .icon {
  display: block;
  background: #c30c15;
  width: 36px;
  height: 36px;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  font-size: x-large;
  font-weight: initial;
  padding: 6px;
  margin: auto;
  margin-bottom: 5px;
}

cwc-location-details .store-info {
  position: relative;
  display: flex;
}

cwc-filter .accordion {
  text-align: center;
}

cwc-map-content .store-details .panel {
  padding: 0 25px 0 37px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
  -webkit-transition: max-height 0.5s ease-out;
}

cwc-filter .panel {
  display: block;
  width: 100%;
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
  -webkit-transition: max-height 0.5s ease-out;
}

cwc-filter .filter-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 5px 0;
  border-bottom: 1px solid #ccc;
}

cwc-filter .filter-item.first {
  padding-top: 0;
}

cwc-filter .filter-item.last {
  border-bottom: none;
  padding-bottom: 0;
}

cwc-filter .filter-item label {
  padding-left: 0.4em;
}

cwc-map-notice {
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  width: 100%;
  height: 100%;
  z-index: 3;
}

cwc-map-notice.notice {
  opacity: 0;
  background: rgba(0, 0, 0, 0.4);
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
}

cwc-map-notice.show {
  display: block;
  opacity: 1;
}

cwc-map-notice notice-content {
  position: absolute;
  width: 100%;
  top: 48%;
  left: 0;
  text-align: center;
  font-size: medium;
  line-height: 42px;
  font-weight: 300;
  color: #fff;
}

/**
 * Search box
 */
cwc-map-search {
  position: absolute;
  top: 0;
  width: 100%;
}

cwc-map-search.load {
  display: block;
  position: inherit;
  top: inherit;
  margin-top: 20px;
  margin-bottom: 20px;
}

cwc-map-search.load input {
  border: 2px solid rgba(0, 0, 0, 0.6);
  border-radius: 5px;
}

cwc-map-search > input {
  position: relative;
  display: flex;
  top: 30%;
  width: 40%;
  padding: 5px 85px 5px 10px;
  margin: 0 auto;
  font-size: medium;
  line-height: 2;
  height: 46px;
  border: none;
}

cwc-map-search input:focus-visible {
  outline: none;
}

cwc-map-search .pac-target-buttons {
  position: absolute;
  top: 1px;
  right: 30%;
}

cwc-map-search .pac-target-buttons .pac-target-button {
  border: 0;
  height: 44px;
  width: auto;
  background-color: transparent;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  line-height: 2.5;
  box-sizing: border-box;
  padding: 0;
  margin-right: 5px;
}

cwc-map-search .pac-target-buttons button.icon-location {
  line-height: 0;
}

cwc-map-search .pac-target-buttons button.icon-close {
  visibility: hidden;
}

cwc-map-search .onsite-printer-only-checkbox {
  width: 40%;
  margin: 0 auto;
  padding-top: 20px;
  text-align: center;
}

/**
 * Map control
 */
cwc-map-control.controls {
  position: absolute;
  font-size: 32px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
  box-sizing: border-box;
  cursor: pointer;
  font-weight: 900;
  display: flex;
  flex-direction: column;
  height: auto;
  margin: 20px 10px;
  text-align: center;
  user-select: none;
  padding: 2px;
  width: 1em;
}

cwc-map-control.controls button {
  border: 0;
  background-color: white;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
}

cwc-map-control.controls button:hover {
  color: var(--color-primary, #c30c15);
}

cwc-map-control.controls.zoom-control {
  top: 15px;
  right: 10px;
}

cwc-map-control.controls.zoom-control button {
  font: 0.85em Arial;
  margin: 1px;
  padding: 0;
}

cwc-map-control.controls.location-control {
  margin-bottom: 105px;
  bottom: 0px;
  right: 10px;
}

cwc-map-control.controls.location-control button {
  font-size: x-large;
  padding: 2px;
  height: 29px;
}

.itinerary-controls {
  margin: 10px 0;
  border: none;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  height: 43px;
  display: flex;
}

[id^='origin-input'],
[id^='destination-input'] {
  display: flex;
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 12px;
  text-overflow: ellipsis;
  width: 250px;
}

#origin-input:focus,
#destination-input:focus {
  border-color: var(--color-primary, #c30c15);
}

#mode-selector input[type='radio'] {
  appearance: none;
}

#mode-selector label {
  height: 43px;
  width: 84px;
  cursor: pointer;
  margin: 0 auto;
  text-align: center;
  background-color: #f5f5f5;
  transition: 0.5s;
  -webkit-transition: 0.5s;
}

i[class^='fa'] {
  font-size: large;
  line-height: 3.1;
}

#mode-selector input[type='radio']:checked + label i:before {
  color: #fff;
}

#mode-selector input[type='radio']:checked + label {
  background-color: var(--color-primary, #c30c15);
  color: #fff;
}

.slidecontainer {
  margin-top: 1em;
}

.slider {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 4px;
  background: #c30c15;
  outline: none;
  margin-top: 1em;
  border-radius: none;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  border-radius: 50%;
  border: 0;
  width: 28px;
  height: 28px;
  background: #fff;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.15);
}

form {
  color: #555;
  display: flex;
  padding: 2px;
  border: 1px solid currentColor;
  border-radius: 5px;
}

input[type='search'] {
  border: none;
  background: transparent;
  width: 90%;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type='search']::placeholder {
  color: #bbb;
}

button[type='submit'] {
  text-indent: -999px;
  overflow: hidden;
  width: 10%;
  padding: 0;
  margin: 0;
  border: 1px solid transparent;
  border-radius: inherit;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat center;
  cursor: pointer;
  opacity: 0.7;
}

button[type='submit']:hover {
  opacity: 1;
}

button[type='submit']:focus,
input[type='search']:focus {
  box-shadow: 0 0 3px 0 var(--color-primary, #c30c15);
  border-color: var(--color-primary, #c30c15);
  outline: none;
}

.directions-panel .adp button,
.directions-panel .adp-legal,
.directions-panel .adp-warnbox,
.directions-panel .adp-agencies,
.directions-panel .adp-placemark,
.directions-panel .adp-stepicon {
  display: none;
}

.directions-panel .adp-summary,
.directions-panel .adp-listheader {
  font-weight: 700;
  padding: 10px 0;
}

.directions-panel .adp-list {
  border-bottom: none;
  border-left: none;
  border-right: none;
  padding: 4px 0;
}

.directions-panel .adp-substep {
  border: none;
  padding: 10px;
}

.directions-panel .adp-substep:first-child {
  padding: 0;
}

.directions-panel .adp-substep:last-child {
  width: 10%;
}

.directions-panel .adp-directions tr {
  background-color: #f5f5f5;
  display: block;
  border-bottom: 8px solid #fff;
}

.directions-panel .adp-substep:nth-child(2) {
  font-weight: 500;
}

/**
 * Switch
 */
.switch {
  position: relative;
  display: block;
  width: 100px;
  height: 30px;
  padding: 3px;
  margin: 0 10px 10px 0;
  background: linear-gradient(to bottom, #eeeeee, #ffffff 25px);
  background-image: -webkit-linear-gradient(top, #eeeeee, #ffffff 25px);
  border-radius: 18px;
  box-shadow:
    inset 0 -1px white,
    inset 0 1px 1px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  box-sizing: content-box;
}

.switch-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  box-sizing: content-box;
}

.switch-label {
  position: relative;
  display: block;
  height: inherit;
  font-size: 10px;
  text-transform: uppercase;
  background: #eceeef;
  border-radius: inherit;
  box-shadow:
    inset 0 1px 2px rgba(0, 0, 0, 0.12),
    inset 0 0 2px rgba(0, 0, 0, 0.15);
  box-sizing: content-box;
}

.switch-label:before,
.switch-label:after {
  position: absolute;
  top: 50%;
  margin-top: -0.5em;
  line-height: 1;
  -webkit-transition: inherit;
  -moz-transition: inherit;
  -o-transition: inherit;
  transition: inherit;
  box-sizing: content-box;
}

.switch-label:before {
  content: attr(data-off);
  right: 11px;
  color: #aaaaaa;
  text-shadow: 0 1px rgba(255, 255, 255, 0.5);
}

.switch-label:after {
  content: attr(data-on);
  left: 11px;
  color: #ffffff;
  text-shadow: 0 1px rgba(0, 0, 0, 0.2);
  opacity: 0;
}

.switch-input:checked ~ .switch-label {
  background: #e1b42b;
  box-shadow:
    inset 0 1px 2px rgba(0, 0, 0, 0.15),
    inset 0 0 3px rgba(0, 0, 0, 0.2);
}

.switch-input:checked ~ .switch-label:before {
  opacity: 0;
}

.switch-input:checked ~ .switch-label:after {
  opacity: 1;
}

.switch-handle {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 28px;
  height: 28px;
  background: linear-gradient(to bottom, #ffffff 40%, #f0f0f0);
  background-image: -webkit-linear-gradient(top, #ffffff 40%, #f0f0f0);
  border-radius: 100%;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
}

.switch-handle:before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -6px 0 0 -6px;
  width: 12px;
  height: 12px;
  background: linear-gradient(to bottom, #eeeeee, #ffffff);
  background-image: -webkit-linear-gradient(top, #eeeeee, #ffffff);
  border-radius: 6px;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);
}

.switch-input:checked ~ .switch-handle {
  left: 74px;
  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
}

/**
 * Transition
 */
.switch-label,
.switch-handle {
  transition: All 0.3s ease;
  -webkit-transition: All 0.3s ease;
  -moz-transition: All 0.3s ease;
  -o-transition: All 0.3s ease;
}

/**
 * Switch Left Right
 */
.switch-left-right .switch-label {
  overflow: hidden;
}

.switch-left-right .switch-label:before,
.switch-left-right .switch-label:after {
  width: 20px;
  height: 20px;
  top: 4px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 11px 0 0 0;
  text-indent: -12px;
  border-radius: 20px;
  box-shadow:
    inset 0 1px 4px rgba(0, 0, 0, 0.2),
    inset 0 0 3px rgba(0, 0, 0, 0.1);
}

.switch-left-right .switch-label:before {
  background: #eceeef;
  text-align: left;
  padding-left: 80px;
}

.switch-left-right .switch-label:after {
  text-align: left;
  text-indent: 9px;
  background: green;
  left: -100px;
  opacity: 1;
  width: 100%;
}

.switch-left-right .switch-input:checked ~ .switch-label:before {
  opacity: 1;
  left: 100px;
}

.switch-left-right .switch-input:checked ~ .switch-label:after {
  left: 0;
}

.switch-left-right .switch-input:checked ~ .switch-label {
  background: inherit;
}

.open-stores,
.distance-filter,
[class^='opening-hours'] {
  display: flex;
  justify-content: space-between;
}

[class^='opening-hours'] div {
  float: left;
  left: 60%;
}

[class^='opening-hours'] span {
  display: flex;
  right: 40%;
}

.all-products {
  display: none;
}

.badge {
  background-color: var(--color-primary, #c30c15);
  color: white;
  padding: 3px 9px;
  height: auto;
  text-align: center;
  border-radius: 50%;
}

.stores-found {
  display: block;
  font-weight: bold;
  margin: 15px 0;
}

.accepted-keys {
  display: inline;
  font-family: Verdana, sans-serif;
  font-size: 10px;
}

.accepted-keys > span:not(:first-child) {
  background-color: #c8c2c2;
  color: black;
  padding: 2px 5px;
  margin: 2px;
  border-radius: 10%;
  width: fit-content;
  width: -webkit-fit-content;
  width: -moz-fit-content;
}

.accepted-keys > span:not(:first-child):hover {
  cursor: pointer;
  border: solid black;
}

.snackbar {
  visibility: hidden;
  min-width: 250px;
  margin-left: -125px;
  background-color: var(--color-primary, #c30c15);
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 50%;
  bottom: 30px;
}

.snackbar.show {
  visibility: visible;
  animation:
    fadein 0.5s,
    fadeout 0.5s 2.5s;
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }

  to {
    bottom: 30px;
    opacity: 1;
  }
}

@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }

  to {
    bottom: 0;
    opacity: 0;
  }
}

@media only screen and (max-width: 768px) {
  cwc-map-content {
    height: 100%;
  }

  cwc-map-search input {
    width: 80%;
    padding-right: 45px;
  }

  cwc-map-control.controls.location-control {
    margin-bottom: 20px;
  }

  cwc-sidebar-slide {
    display: none;
  }

  cwc-map-search .pac-target-buttons {
    right: 10%;
  }

  cwc-map-sidebar {
    height: 100%;
    display: contents !important;
  }

  cwc-map.sidebar-on {
    max-width: 100%;
    height: 270px;
    left: 0;
  }

  cwc-map.slide {
    left: 0;
    width: 100%;
  }

  cwc-location-details .product_images .img-items.open .img-item {
    max-width: calc(50% - 8px);
  }

  cwc-product-images .preview-items-wrapper {
    width: 90%;
  }
}
